import React, {
  useEffect, useState, Fragment, useMemo,
} from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Select, Dropdown, Checkbox, Tag,
  Popover,
  Tooltip,
  Divider,
  Drawer,
} from 'antd';
import {
  FilterOutlined, ControlOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

import CFV2Actions from '@Actions/configurations/cfV2Actions';
import H3Text from '@Uilib/h3Text';
import SOActions from '@Actions/sales/soActions';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { toISTDate, CountryCodes, entityNameEnum, filterTypeEnums } from '@Apis/constants';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import H3DateSelector from '@Uilib/h3DateSelector';
import SelectDepartment from '@Components/Common/SelectDepartment';
import SelectUser from '@Components/Common/SelectUser';
import TenantActions from '@Actions/tenantActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import SelectStatus from '../../../Common/SelectCustomStatus';
import documentUINamesConstant from '../../../../apis/documentUINamesConstant';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import ListScreenKeys from './mobileListHelper';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector';
import { dateRangePresets, dateRangePresetsValues } from '../../../../apis/constants';
import './style.scss';

const { Option } = Select;

const fixedColumns = ['PS_CODE', 'CUSTOMER', 'SO_CODE'];

function PackingSlipList({
  packingSlips, getPSLoading, user, getSO, history, getCustomStatus, getOrgUsers, orgUsers,
  getDocCFV2, customFieldsPackingSlip, getDocCFV2Loading, departments, getDocCFV2Success, updateSOStatus, updateSOStatusLoading, customStatusPackingSlip, getCustomStatusPackingSlipLoading,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [call, setCall] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedCustomStatus, setSelectedCustomStatus] = useState(null);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCustomStatusId, setSelectedCustomStatusId] = useState('');
  const [selectedAssignee, setSelectedAssignee] = useState([]);

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-so') ? JSON.parse(localStorage.getItem('prcz-page-columns-so')) : {
    PS_CODE: {
      label: 'Packing Slip #',
      visible: true,
    },
    CUSTOMER: {
      label: 'Customer',
      visible: true,
    },
    SO_CODE: {
      label: `${documentUINames.salesOrderUIName} #`,
      visible: true,
    },
    ITEMS: {
      label: 'Items',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: false,
    },
    ORDER_DATE: {
      label: 'Packing Date',
      visible: true,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    SALES_MANAGER: {
      label: 'Sales Manager',
      visible: true,
    },
    GATE_DOCUMENT: {
      label: 'Gate Document',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
  });
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);

  const [selectedPackingSlip, setSelectedPackingSlip] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);

  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const getCustomFieldsProps = () => customFieldsPackingSlip;

  const getSalesOrderColumns = () => {
    const salesColumns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <Link to={`/sales/packing-slip/view/${record.order_id}`}>
      //       <div className="mobile-list__item">
      //         <div style={{ display: 'flex' }}>
      //           <H3Text text={`#${record?.sales_order_number}`} className="mobile-list__item-number" />
      //           <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
      //             {Helpers.getStatusColor(record?.status)?.text?.toUpperCase()}
      //           </div>
      //         </div>
      //         {record?.customer_info && (
      //           <div className="mobile-list__item-info">
      //             {`Customer - ${record?.customer_info?.customer_name}`}
      //           </div>
      //         )}
      //         <div className="vendor-mobile-list__item-footer">
      //           <H3Text text={`Requested by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer-left" />
      //         </div>
      //       </div>
      //     </Link>
      //   ),
      //   responsive: ['xs'],
      // },
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <Link
                // to={`/sales/packing-slip/view/${record.order_id}`}
                >
                  <PRZText
                    text={`#${record?.sales_order_number}`}
                    className="mobile-list__card_item-number"
                  />
                </Link>
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  className="mobile-list__card__status"
                  style={{
                    backgroundColor: record?.custom_status_info?.color_code,
                  }}
                  text={record?.custom_status_info?.status_name?.replaceAll('_', ' ').toProperCase()}
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                {record?.customer_info?.customer_name ? (
                  <div className="mobile-list__card_item-name_wrapper">
                    <Tooltip
                      title={
                        Helpers.getPermission(Helpers.permissionEntities.CUSTOMER,
                          Helpers.permissionTypes.READ, user)
                          ? (
                            <Link
                            // to={`/inventory/product/view/${record?.product_sku_id}?tab=/general-information`}
                            >
                              <PRZText
                                className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                                text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                              />
                            </Link>
                          ) : (
                            <PRZText
                              className="mobile-list__card_item__tooltip_text-link mobile-list__card_item__category__tooltip"
                              text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                            />
                          )
                      }
                      color="white"
                    >
                      <PRZText text={`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`} className="mobile-list__card_item-name" />
                    </Tooltip>
                  </div>
                ) : '-'}

                <PRZText text={`Packing Date: ${dayjs(record?.order_date).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details" />

                {record?.ps_so_details?.order_id && (
                  <PRZText
                    text={(
                      <React.Fragment>
                        <span>{documentUINames.salesOrderUIName.toProperCase()}</span>
                        <span>#: </span>
                        <span>
                          {Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user) ? (
                            <React.Fragment>
                              <Link
                              // to={`/sales/sales-order/view/${record?.ps_so_details?.order_id}`}
                              // target="_blank"
                              >
                                <span style={{
                                  fontWeight: 600,
                                }}
                                >
                                  {`${record?.ps_so_details?.sales_order_number}`}
                                </span>
                              </Link>
                            </React.Fragment>
                          ) : record?.ps_so_details?.sales_order_number}
                        </span>
                      </React.Fragment>
                    )}
                    className="mobile-list__card_item-details"
                  />
                )}
                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${record?.tenant_info?.tenant_name} (${record?.tenant_department_info?.department_name})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Location: ${record?.tenant_info?.tenant_name} (${record?.tenant_department_info?.department_name})`} className="mobile-list__card_item-details" />
                </Tooltip>

                <PRZText text={`Sales Manager: ${record?.account_manager_info?.account_manager_id ? (`${record?.account_manager_info?.first_name} ${record?.account_manager_info?.last_name}`) : 'N/A'}`} className="mobile-list__card_item-details" />

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${dayjs(record?.created_at).format('DD/MM/YYYY')} ( ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Created By ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'} on ${dayjs(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details created_by_info" />
                </Tooltip>

              </div>
              <div className="mobile-list__card_body-right">
                <div className="mobile-list__card_item_status_wrapper">
                  <div></div>
                </div>

              </div>
            </div>

            <Divider className="mobile-list__card_divider" />

            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <div></div>
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedPackingSlip(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'PACKING SLIP #',
        // dataIndex: 'sales_order_number',
        render: (record) => (
          <div className="column-number__wrapper min-width-115">
            {record?.sales_order_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PS_CODE?.visible ? 'display-none' : '',
        fixed: 'left',
      },
    ];
    const fixedColumn = [
      {
        title: 'CUSTOMER',
        render: (text, record) => (
          <div className="associated-entity min-width-70">
            {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER,
              Helpers.permissionTypes.READ, user)
              ? (record?.customer_info?.customer_name ? (
                <Link to={`/sales/customer/view/${record?.customer_id}`} target="_blank">
                  {`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`}
                </Link>
              ) : '-') : (`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CUSTOMER?.visible ? 'display-none' : '',
      },
      {
        title: `${documentUINames.salesOrderUIName.toUpperCase()} #`,
        render: (text, record) => (
          <div className={`associated-entity ${Helpers.setColumnMinimumWidth(`${documentUINames.salesOrderUIName} #`)}`}>
            {(Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user))
              ? (record?.ps_so_details?.order_id ? (
                <Link to={`/sales/sales-order/view/${record?.ps_so_details?.order_id}`} target="_blank">
                  {`${record?.ps_so_details?.sales_order_number}`}
                </Link>
              ) : '-') : (`${record?.ps_so_details?.sales_order_number}`)}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SO_CODE?.visible ? 'display-none' : '',
      },
      {
        title: 'SALES MANAGER',
        render: (text, record) => (
          <div className='min-width-100'>
            {record?.account_manager_info?.account_manager_id ? (`${record?.account_manager_info?.first_name} ${record?.account_manager_info?.last_name}`) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.SALES_MANAGER?.visible ? 'display-none' : '',
      },
      {
        title: 'GATE DOCUMENT NUMBER',
        width: '200px',
        render: (record) => {
          const gateDocNumber = record?.ref_gate_document;

          const otherDocs = (
            <div>
              {
                gateDocNumber?.slice(2).map((document, i) => (
                  <div className="other-uom-stock" key={i}>
                    <div
                      onClick={() => window.open(`/logistic/gate-document/view/${document?.gate_document_id}`)}
                      style={{
                        cursor: 'pointer',
                      }}
                    >
                      {document?.gate_document_number}
                    </div>
                  </div>
                ))
              }
            </div>
          );
          return (
            <Popover
              placement="bottom"
              content={gateDocNumber?.length > 2 && otherDocs}
              trigger="hover"
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
              <div className="associated-entity min-width-150">
                {gateDocNumber?.slice(0, 2)?.map((document) => (
                  <Link
                    to={`/logistic/gate-document/view/${document?.gate_document_id}`}
                    target="_blank"
                    key={document?.gate_document_id}
                  >
                    <div className="customer-table__name">
                      {document?.gate_document_number}
                    </div>
                  </Link>
                ))}
                {gateDocNumber?.length > 2 && (
                  <H3Text
                    className="table-subscript-grey"
                    text={`and ${gateDocNumber.length - 2} more`}
                  />
                )}
              </div>
            </Popover>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.GATE_DOCUMENT?.visible ? 'display-none' : '',
      },
      {
        title: 'LOCATION',
        render: (text, record) => (
          <div className="min-width-70">
            {record?.tenant_info?.tenant_name}
            <H3Text text={record?.tenant_department_info?.department_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'ITEMS',
        render: (item) => (
          <div className="min-width-50">
            {item?.line_count || 0}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ITEMS?.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        render: (record) => (
          <div className="min-width-100">
            <div className="column-date">
              {dayjs(record?.created_at).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CREATED_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'PACKING DATE',
        render: (record) => (
          <div className="column-date min-width-100">
            {dayjs(record?.order_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ORDER_DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
    ];
    salesColumns.push(...fixedColumn);
    if (getCustomFieldsProps()?.data?.document_custom_fields?.length) {
      const customs = getCustomFieldsProps()?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.filter((item) => item?.is_active)?.map((custom) => {
        salesColumns.push({
          title: custom?.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record?.custom_fields?.filter((subItem) => subItem?.cf_id === custom?.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom?.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    const addAlpha = (color, opacity) => {
      // coerce values so ti is between 0 and 1.
      const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return color + _opacity.toString(16).toUpperCase();
    };
    salesColumns.push(
      {
        title: '',
        key: 'action',
        render: (record) => (
          <div className="list__actions">
            <div className="list__actions-button list__actions-status-selector">
              <SelectStatus
                selectedCustomStatus={record?.custom_status_id}
                hideTitle
                tenantId={selectedTenant?.join(',')}
                posibleStatuses={[record?.custom_status_info, ...record?.possible_status]}
                onChange={(value) => {
                  updateSOStatus({
                    status: value?.type,
                    secondary_status: value?.status_name,
                    order_id: record?.order_id,
                    custom_status_id: value?.custom_status_id,
                  }, () => {
                    setCall(!call);
                  });
                }}
                disabled={['VOID', 'SENT_FOR_APPROVAL'].includes(record?.custom_status_info?.type) || !record?.custom_status_id}
                customStyle={{
                  color: record?.custom_status_info?.color_code,
                  backgroundColor: addAlpha(record?.custom_status_info?.color_code, 0.9),
                  fontSize: '11px',
                  height: '50px',
                }}
                dropdownAlign={{ offset: [0, 12] }}
              />
            </div>
            {!isPortrait && (
              <div
                className="list__actions-button list__actions-button-dark"
                onClick={() => {
                  history.push(`/sales/packing-slip/view/${record?.order_id}`);
                }}
              >
                View
              </div>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        fixed: 'right',
        className: 'list__actions-column',
      },
    );

    return salesColumns.filter((item) => !item.hidden);
  };

  const pushParamsToUrl = (page, limit, word, status, currentTenant, startDate, endDate, dept, customStatus, customStatusId, accountManager, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    url += '&list_screen=true';
    if (limit) url += `&limit=${limit}`;
    if (word) url += `&keyword=${word}`;
    if (status) url += `&status=${status}`;
    if (customStatus) url += `&custom_status=${customStatus}`;
    if (customStatusId) url += `&custom_status_id=${customStatusId}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (dept) url += `&department=${dept}`;
    if (accountManager) url += `&accountManager=${selectedAssignee?.map((item) => (item?.userId))?.join(',')}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  function getOrderDataLoading() {
    return getPSLoading;
  }

  function getOrderData() {
    return packingSlips;
  }

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status',
        filter_value: Helpers.getValueFromUrl('custom_status') || null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status_id',
        filter_value: Number(Helpers.getValueFromUrl('custom_status_id')) || null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'department',
        filter_value: Helpers.getValueFromUrl('department') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'accountManager',
        filter_value: Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
          userId: parseInt(item),
          title: parseInt(item) === 0 ? 'Unassigned' : `${orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
          identity: parseInt(item) === 0 ? 'UA' : orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        })) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    const restrictAccountManagerPermissionCheck = user?.tenant_info?.sales_config?.sub_modules?.packing_slip?.settings?.restrict_orders_of_other_acc_manager;
    return [
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'status',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status',
        filter_value: null,
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'custom_status_id',
        filter_value: null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'endDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'department',
        filter_value: Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility ? Number(Helpers.getDepartmentId(user)) : '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'accountManager',
        filter_value: restrictAccountManagerPermissionCheck ? [{
          userId: user?.user_id,
          title: `${user?.first_name} ${user?.last_name}`?.trim(),
          identity: user?.first_name?.substring(0, 2).toUpperCase(),
        }] : [],
        filter_type: filterTypeEnums.ARRAY,
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.PACKING_SLIP,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;
        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedStatus(tempFilterValues.status);
        setSelectedCustomStatus(tempFilterValues.custom_status);
        setSelectedCustomStatusId(tempFilterValues.custom_status_id);
        setSelectedTenant(tempFilterValues.tenant);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setSelectedAssignee(tempFilterValues.accountManager);
        setSelectedDepartment(tempFilterValues.department);

        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          // setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user)?.toString());
        } else {
          // setSelectedDepartment(Helpers.getValueFromUrl('department'));
        }

        // if (user?.tenant_info?.sales_config?.sub_modules?.packing_slip?.settings?.restrict_orders_of_other_acc_manager) {
        //   setSelectedAssignee([{
        //     userId: user?.user_id,
        //     title: `${user?.first_name} ${user?.last_name}`?.trim(),
        //     identity: user?.first_name?.substring(0, 2).toUpperCase(),
        //   }]);
        // } else {
        //   setSelectedAssignee(tempFilterValues.accountManager || []);
        // }
      }
      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (user?.tenant_info) {
      getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.READ)?.join(','), (orgUsersData) => {
        setSelectedAssignee(Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
          userId: parseInt(item),
          title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
          identity: parseInt(item) == 0 ? 'UA' : orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        })) : []);
      });
      getCustomStatus({
        entityName: 'PACKING_SLIP',
        orgId: user?.tenant_info?.org_id,
      }, () => { });
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'PACKING_SLIP',
      };
      getDocCFV2(payload);
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Helpers.getValueFromUrl('limit') || limit);
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // setSelectedStatus(Helpers.getValueFromUrl('status'));
      // setSelectedCustomStatus(Helpers.getValueFromUrl('custom_status'));
      // setSelectedCustomStatusId(Number(Helpers.getValueFromUrl('custom_status_id')) || '');
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
      // setStartDate(Number(Helpers.getValueFromUrl('startDate')));
      // setEndDate(Number(Helpers.getValueFromUrl('endDate')));
      // setSelectedAssignee(Helpers.getValueFromUrl('accountManager') ? Helpers.getValueFromUrl('accountManager')?.split(',')?.map((item) => ({
      //   userId: parseInt(item),
      //   title: `${orgUsers?.data?.find((i) => item?.user_id === parseInt(item))?.first_name}`?.trim(),
      //   identity: orgUsers?.data?.find((i) => item?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
      // })) : []);
      // if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
      //   setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
      //   setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user)?.toString());
      // } else {
      //   setSelectedDepartment(Helpers.getValueFromUrl('department'));
      // }
      // setIsUserReady(true);
    }
    // if (user?.tenant_info?.sales_config?.sub_modules?.packing_slip?.settings?.restrict_orders_of_other_acc_manager) {
    //   setSelectedAssignee([{
    //     userId: user?.user_id,
    //     title: `${user?.first_name} ${user?.last_name}`?.trim(),
    //     identity: user?.first_name?.substring(0, 2).toUpperCase(),
    //   }]);
    // } else {
    //   setSelectedAssignee([]);
    // }
    setSelectedFilterView(systemDefaultUserView);
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (getCustomFieldsProps()?.data?.document_custom_fields?.length) {
      const customFields = getCustomFieldsProps()?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-so'))?.[customField.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, [getCustomFieldsProps()]);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedStatus, selectedTenant, startDate, endDate, selectedDepartment, selectedCustomStatus, selectedCustomStatusId, selectedAssignee, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getSO({
        orgId: user?.tenant_info?.org_id,
        tenantId: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.READ)?.join(','),
        status: Helpers.getValueFromUrl('status'),
        page: Helpers.getValueFromUrl('page'),
        limit: Helpers.getValueFromUrl('limit'),
        searchKeyword: Helpers.getValueFromUrl('keyword'),
        startDate: Helpers.getValueFromUrl('startDate'),
        endDate: Helpers.getValueFromUrl('endDate'),
        departmentId: Helpers.getValueFromUrl('department'),
        listScreen: Helpers.getValueFromUrl('list_screen'),
        secondaryStatus: Helpers.getValueFromUrl('custom_status'),
        accountManagerIds: Helpers.getValueFromUrl('accountManager'),
        orderType: 'PACKING_SLIP'
      }, () => {
        setSelectedRows([]);
        setSelectedRowKeys([]);
      });
    }
  }, [searchKeyword, currentPage, limit, call, selectedStatus, selectedTenant, startDate, endDate, selectedDepartment, selectedCustomStatus, selectedAssignee, orderDateSelectedIntervalDateRangeType,
    // selectedFilterView
  ]);


  const getDataSource = (data) => {
    if (data) {
      const copyData = JSON.parse(JSON.stringify(data));
      return copyData?.map((item) => ({ ...item, key: item?.order_id }));
    }
    return [];
  };

  const getCustomStatusData = () => {
    return customStatusPackingSlip;
  };

  const getCustomStatusLoading = () => {
    return getCustomStatusPackingSlipLoading;
  };

  const statusOptions = [
    { value: null, label: "All Status" },
    ...getCustomStatusData()?.statuses?.map((item) => ({
      value: item?.status_name,
      label: item?.status_name?.split('_')?.join(' ')?.toProperCase(),
    })) || []
  ];

  return (
    <Fragment>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedPackingSlip?.customer_info?.customer_name} - ${selectedPackingSlip?.customer_info?.internal_cust_code}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedPackingSlip?.custom_fields}
          documentData={selectedPackingSlip}
          fields={ListScreenKeys({ documentData: selectedPackingSlip })}
        />
      </Drawer>

      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">

            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Sales Packing Slip"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.CREATE, user) && (
                  <div className="doc-list__buttons-wrapper">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text={'+ New Packing Slip'}
                      onClick={() => {
                        history.push('/sales/packing-slips/create');
                      }}
                      customClass="add-button hide__in-mobile"
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;
                    // const tempFilterValues = {
                    //   keyword: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'keyword' }),
                    //   limit: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'limit' }),
                    //   page: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'page' }),
                    //   status: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'status' }),
                    //   custom_status: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'custom_status' }),
                    //   custom_status_id: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'custom_status_id' }),
                    //   tenant: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'tenant' }),
                    //   startDate: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate' }),
                    //   endDate: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'endDate' }),
                    //   department: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'department' }),
                    //   accountManager: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'accountManager' }),
                    // };

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedStatus(tempFilterValues.status);
                    setSelectedCustomStatus(tempFilterValues.custom_status);
                    setSelectedCustomStatusId(tempFilterValues.custom_status_id);
                    setSelectedTenant(tempFilterValues.tenant);
                    setStartDate(tempFilterValues.startDate);
                    setEndDate(tempFilterValues.endDate);
                    setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    setSelectedAssignee(tempFilterValues.accountManager);
                    setSelectedDepartment(tempFilterValues.department);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.PACKING_SLIP}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search for
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
                {selectedStatus && (
                  <Tag closable onClose={() => { setSelectedStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedCustomStatus && (
                  <Tag closable onClose={() => { setSelectedCustomStatus(null); setCurrentPage(1); setSelectedCustomStatusId(null); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedCustomStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {
                  (startDate && endDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDate(null);
                        setEndDate(null);
                        setOrderDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      {`${(getOrderData() && getOrderData()?.data?.count) ? getOrderData()?.data?.count : '0'} Packing Slip`}
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <div className="select-user__filter-wrapper">
                          <SelectUser
                            selectedUsers={selectedAssignee}
                            onSelect={(userId) => {
                              setCurrentPage(1)
                              setSelectedAssignee([...selectedAssignee, {
                                userId,
                                title: userId === 0 ? 'Unassigned' : `${orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name}`?.trim(),
                                identity: userId === 0 ? 'UA' : orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name?.substring(0, 2).toUpperCase(),
                              }]);
                            }}
                            onRemove={(userId) => {
                              setSelectedAssignee([...selectedAssignee?.filter((item) => item?.userId !== userId)]);
                            }}
                            disabled={user?.tenant_info?.sales_config?.sub_modules?.packing_slip?.settings?.restrict_ps_of_other_acc_manager}
                          />
                        </div>
                        <H3DateSelector
                          selectedInterval={orderDateSelectedIntervalDateRangeType}
                          startDate={startDate}
                          endDate={endDate}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                            setCurrentPage(1);
                            setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />
                      </div>
                      <Dropdown
                        trigger={['click']}
                        overlay={(
                          <div className="header__filter__container">
                            <div className="header__filter__container__title">
                              Apply Filters
                            </div>
                            <div className="filter__container filter__container-section">
                              <div className="filter__title"> Select Business Unit </div>
                              <TenantSelector
                                selectedTenant={selectedTenant}
                                showSearch
                                showAll={false}
                                noDropdownAlign
                                isMultiple
                                onChange={(value) => {
                                  setCurrentPage(1);
                                  setSelectedTenant(value);
                                }}
                                placeholder="Select Business Unit"
                                hideTitle
                                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.READ)}
                              />
                            </div>
                            <div className="filter__container filter__container-section">
                              <div className="filter__title"> Select Department </div>
                              <SelectDepartment
                                title="Select Department"
                                hideTitle
                                selectedDepartment={Number(selectedDepartment) || ''}
                                noDropdownAlign
                                onChange={(value) => {
                                  setSelectedDepartment(value?.department_id.toString() || '');
                                  setCurrentPage(1);
                                }}
                                disabled={departmentLevelVisibility}
                              />
                            </div>
                            <div className="filter__container filter__container-section">
                              <div className="filter__title">Packing Status</div>
                              <PRZSelect
                                value={selectedCustomStatus}
                                onChange={(value) => {
                                  const requiredStatus = getCustomStatusData()?.statuses?.filter((status) => status?.status_name === value)[0];
                                  setSelectedCustomStatus(requiredStatus?.status_name);
                                  setSelectedCustomStatusId(requiredStatus?.custom_status_id);
                                  setSelectedRowKeys(null);
                                  setSelectedRows(null);
                                  setCurrentPage(1);
                                }}
                                placeholder="Packing Status"
                                options={statusOptions}
                              />
                            </div>
                          </div>
                        )}
                      >
                        <div className="doc-list__action-buttons">
                          <div className="action-button">
                            <H3Text text="Filters" className="action-button-text" />
                            <FilterOutlined />
                          </div>
                        </div>
                      </Dropdown>
                      <Dropdown
                        overlay={(
                          <div className="custom-columns__content">
                            <div className="custom-columns__content-section">
                              <H3Text text="Visible Columns" className="custom-columns__content-title" />
                              {
                                Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                  <div key={key}>
                                    <Checkbox
                                      disabled={fixedColumns.includes(key)}
                                      checked={visibleColumns[key]?.visible}
                                      onChange={(value) => {
                                        const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                        visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                        localStorage.setItem('prcz-page-columns-so', JSON.stringify(visibleColumnsCopy));
                                        setVisibleColumns(visibleColumnsCopy);
                                      }}
                                    >
                                      {visibleColumns[key]?.label}
                                    </Checkbox>
                                  </div>
                                ))
                              }
                            </div>
                            {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                              <div className="custom-columns__content-section">
                                <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={(value) => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                          localStorage.setItem('prcz-page-columns-so', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                            ) : ''}
                          </div>
                        )}
                        trigger={['click']}
                        placement="bottomRight"
                      >
                        <div className="custom-columns__wrapper">
                          Customize Columns
                          <ControlOutlined />
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                )}
                scroll={!isMobileOrPortrait && !!getDataSource(getOrderData()?.data?.sales_orders)?.length ? { x: 'max-content', y: 'calc(100dvh - 170px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && !!getDataSource(getOrderData()?.data?.sales_orders)?.length}
                loading={getOrderDataLoading() || getDocCFV2Loading || updateSOStatusLoading || getCustomStatusLoading() || savedFilterViewsLoading}
                showHeader
                size="small"
                columns={getSalesOrderColumns()}
                dataSource={getDataSource(getOrderData()?.data?.sales_orders) || []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: getOrderData() ? getOrderData()?.data?.count : 0,
                    pageSize: limit,
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
                rowSelection={!isMobileOrPortrait ? {
                  onChange: (rowKeys, rows) => {
                    setSelectedRowKeys(rowKeys);
                    setSelectedRows(rows);
                  },
                  selectedRowKeys,
                } : false}
                bordered
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, SOReducers, CFV2Reducers, DepartmentReducers, CustomStatusReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  getPSLoading: SOReducers.getPSLoading,
  packingSlips: SOReducers.packingSlips,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  customFieldsPackingSlip: CFV2Reducers.cfV2DocPackingSlip,
  departments: DepartmentReducers.departments,
  updateSOStatusLoading: SOReducers.updateSOStatusLoading,
  customStatusPackingSlip: CustomStatusReducers.customStatusPackingSlip,
  getCustomStatusPackingSlipLoading: CustomStatusReducers.getCustomStatusPackingSlipLoading,
  orgUsers: TenantReducers.orgUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getSO: (payload, callback) => dispatch(SOActions.getSO(payload, callback)),
  updateSOStatus: (payload, callback) => dispatch(SOActions.updateSOStatus(payload, callback)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (customFieldsDocV2) => dispatch(CFV2Actions.getDocCFV2Success(customFieldsDocV2)),
  getCustomStatus: (payload, callback) => dispatch(CustomStatusActions.getCustomStatus(payload, callback)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PackingSlipList));
